var map = {
	"./bank.svg": 3185,
	"./card-applepay.svg": 4400,
	"./card-debit.svg": 9616,
	"./card-fondy.svg": 2330,
	"./card-googlepay.svg": 1743,
	"./card-mastercard.svg": 554,
	"./card-monobank.svg": 933,
	"./card-paypal.svg": 4731,
	"./card-privat24.svg": 8864,
	"./card-visa.svg": 2013,
	"./card.svg": 2505,
	"./cat-headphone.svg": 3624,
	"./comodo-black.svg": 6420,
	"./comodo.svg": 6742,
	"./geoTrust-black.svg": 734,
	"./geoTrust.svg": 6132,
	"./like.svg": 8646,
	"./logo.svg": 3914,
	"./paypal.svg": 1134,
	"./ribbon.svg": 1319,
	"./round-nl.svg": 2980,
	"./round-ua.svg": 3376,
	"./round-us.svg": 6898,
	"./stars-blue.svg": 9351,
	"./stars-grey.svg": 3394,
	"./summary-border.svg": 6204,
	"./terminal.svg": 2183,
	"./thawte-black.svg": 7184,
	"./thawte.svg": 3138,
	"./veriSign-black.svg": 350,
	"./veriSign.svg": 3444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;